import React from "react";
import { Routes, Route } from "react-router-dom";
import ListEvents from "../Components/Events/listEvents";
import ViewEvents from "../Components/Events/viewEvent";
import AddEvents from "../Components/Events/addEvents";
import EditEvents from "../Components/Events/editEvents";

const EventRoutes = () => {
  return (
    <Routes>
      <Route path="/event" element={<ListEvents></ListEvents>}></Route>
      <Route path="/event/view/:id" element={<ViewEvents></ViewEvents>}></Route>
      <Route path="/event/add" element={<AddEvents></AddEvents>}></Route>
      <Route path="/event/edit/:id" element={<EditEvents></EditEvents>}></Route>
    </Routes>
  );
};

export default EventRoutes;
